<template>
  <div class="log">
    <div class="title">消费记录</div>
    <div class="table">
      <div class="table-header">
        <span
          class="header-item"
          :style="{ width: tableWidth[index] ? tableWidth[index] + 'px' : 'auto', flex: tableWidth[index] ? '' : 1}"
          v-for="(item, index) in headerList"
          :key="index"
          >{{ item }}</span
        >
      </div>
      <div class="table-list" v-show="list.length">
        <div class="table-tr" v-for="item,index in list" :key="index">
          <div class="table-th" :style="{ width: tableWidth[0] + 'px'}">
            {{item.trade_no}}
          </div>
          <div class="table-th" :style="{ flex: 1}">
            {{item.order_name}}
          </div>
          <div class="table-th" :style="{ width: tableWidth[2] + 'px'}">
            {{item.date}}
          </div>
          <div class="table-th" :style="{ width: tableWidth[3] + 'px'}">
            {{payMethodMap[item.pay_method]}}
          </div>
          <div class="table-th" :style="{ width: tableWidth[4] + 'px'}">
            {{item.fee}}元
          </div>
        </div>
      </div>
      <NoData tips="暂无消费记录" v-show="!list.length"></NoData>
    </div>
    <footer v-show="list.length">
      <Pagination @jump="getList" :total="total"></Pagination>
    </footer>
  </div>
</template>

<script>
import Pagination from 'components/pagination.vue'
import NoData from 'components/no-data.vue'
import { ListPaymentHistory } from '@/api/pay.js'
import { formatUnixTime } from '@/utils/timeformat.js'
import { formatMoney } from 'utils/utils'

export default {
  name: 'log',
  props: {
    msg: String
  },
  components: {
    Pagination,
    NoData
  },
  data() {
    return {
      tableWidth: [200,'', 200, 200, 100],
      headerList: [
        "订单编号",
        "项目",
        "时间",
        "支付方式",
        "金额",
      ],
      list: [],
      payMethodMap: {
        1: '微信支付',
        2: '支付宝',
        3: '苹果支付'
      },
      total: 0
    };
  },
  created() {
  },
  methods: {
    async getList (page) {
      const res = await ListPaymentHistory(page)
      if (res.code !== 0) {
        return
      }
      const {list, total} = res.data
      const newList = list.map((ele) => {
        ele.date = formatUnixTime(new Date(ele.date).getTime() / 1000)
        ele.fee = formatMoney(ele.fee)
        return ele
      })
      this.list = newList
      this.total = total
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.log {
  background-color: #fff;
  border-radius: 4px;
  padding: 40px;
  height: 100%;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    color: #666666;
  }
  .table {
    width: 100%;
    margin-top: 23px;
    .table-header {
      height: 50px;
      background-color: #f4f5f8;
      font-size: 14px;
      color: #666666;
      line-height: 50px;
      display: flex;
      .header-item {
        display: inline-block;
        text-align: center;
        padding: 0 20px;
      }
    }
    .table-list {
      .table-tr {
        display: flex;
        align-items: center;
        border-bottom: solid 1px #d8d8d8;
        .table-th {
          padding: 15px 20px;
          text-align: center;
          .dubber-image {
            width: 40px;
            height: 40px;
            display: block;
            border-radius: 20px;
          }
          .dubber-name {
            text-align: center;
            margin-top: 5px;
          }
          .pay-button {
            background: #4e6eff;
            border-radius: 4px;
            font-size: 14px;
            color: #ffffff;
            width: 76px;
            height: 26px;
            line-height: 26px;
            margin-top: 3px;
          }
          .svg-icon {
            margin: 0 10px;
            cursor: pointer;
            &:hover {
              filter: invert(85%) sepia(80%) saturate(2500%) hue-rotate(330deg) brightness(115%) contrast(105%);
            }
          }
          .text-desc {
            cursor: pointer;
            .title {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
            .info-content {
              position: relative;
              .svg-icon--bottom_arrow {
                width: 12px;
                height: 12px;
                position: absolute;
                right: -30px;
                top: 4px;
              }
              .info {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                color: #999999;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }
  footer { 
    margin-top: 18px;
  }
}
</style>
